import {useCallback} from 'react';
import {
  useSubtitleTrackService,
  useSubtitlePanelIsOpen,
} from './useTrackContext';

/**
 * Handles toggleing the subtitle panel open and closed.
 * @returns callback to toggle the open state of the subtitle panel
 */
export const useSubtitlePanelToggle = (): (() => void) => {
  const {send} = useSubtitleTrackService();
  const isOpen = useSubtitlePanelIsOpen();

  const onToggle = useCallback(() => {
    send(isOpen ? 'closePanel' : 'openPanel');
  }, [isOpen, send]);

  return onToggle;
};
